// src/pages/SeamsiGamePage.jsx
import React, { useState } from 'react';
import { seamsiFortunes } from '../data/seamsiData';
import { Link } from 'react-router-dom';
import { ChevronLeft, Home } from 'lucide-react'; // หรือ X
// CSS สำหรับ Animation การเขย่า (ใส่ไว้ในไฟล์นี้เลยเพื่อความง่าย)
const shakeStyle = `
  @keyframes shake {
    0% { transform: translate(1px, 1px) rotate(0deg); }
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(3px, 2px) rotate(0deg); }
    40% { transform: translate(1px, -1px) rotate(1deg); }
    50% { transform: translate(-1px, 2px) rotate(-1deg); }
    60% { transform: translate(-3px, 1px) rotate(0deg); }
    70% { transform: translate(3px, 1px) rotate(-1deg); }
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(1px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
  }
  .shaking-element {
    animation: shake 0.5s;
    animation-iteration-count: infinite;
  }
`;

const SeamsiGamePage = () => {
    const [isShaking, setIsShaking] = useState(false);
    const [result, setResult] = useState(null);

    const handleShake = () => {
        if (isShaking) return;

        setIsShaking(true);
        setResult(null);

        // จำลองการเขย่า 2 วินาที แล้วสุ่มผลลัพธ์
        setTimeout(() => {
            const randomIndex = Math.floor(Math.random() * seamsiFortunes.length);
            setResult(seamsiFortunes[randomIndex]);
            setIsShaking(false);
        }, 2000);
    };

    const resetGame = () => {
        setResult(null);
    };

    return (
        <div className="min-h-screen bg-orange-50 flex flex-col items-center justify-center p-4 relative overflow-hidden">
            <div className="absolute top-4 left-4 z-50 flex gap-2">
                <Link
                    to="/games"
                    className="flex items-center justify-center w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full shadow-md text-amber-800 hover:bg-white hover:scale-110 transition-all border border-amber-100"
                    title="กลับไปหน้ารวมเกม"
                >
                    <ChevronLeft className="w-6 h-6" />
                </Link>

                {/* (Optional) ปุ่มกลับหน้าแรกเว็บไซต์ */}
                <Link
                    to="/"
                    className="flex items-center justify-center w-10 h-10 bg-white/80 backdrop-blur-sm rounded-full shadow-md text-amber-800 hover:bg-white hover:scale-110 transition-all border border-amber-100"
                    title="กลับหน้าหลักเว็บไซต์"
                >
                    <Home className="w-5 h-5" />
                </Link>
            </div>
            {/* Inject Style */}
            <style>{shakeStyle}</style>

            {/* Background Decor (ลายไทยจางๆ สมมติ) */}
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none z-0">
                <div className="w-64 h-64 bg-yellow-500 rounded-full blur-3xl absolute -top-10 -left-10"></div>
                <div className="w-64 h-64 bg-red-500 rounded-full blur-3xl absolute -bottom-10 -right-10"></div>
            </div>

            <div className="z-10 text-center max-w-md w-full">
                <h1 className="text-3xl font-bold text-amber-900 mb-2">สุ่มของรางวัล</h1>
                <p className="text-amber-700 mb-8">ตั้งจิตอธิษฐาน แล้วกดเพื่อรับของรางวัล</p>

                {/* กระบอกเซียมซี */}
                <div
                    className={`relative w-48 h-64 mx-auto mb-8 bg-amber-800 rounded-b-3xl rounded-t-lg shadow-xl border-4 border-amber-900 flex items-end justify-center pb-4 cursor-pointer transition-transform ${isShaking ? 'shaking-element' : ''}`}
                    onClick={handleShake}
                >
                    {/* ลวดลายบนกระบอก */}
                    <div className="absolute top-4 w-full h-4 bg-amber-900/50"></div>
                    <div className="absolute bottom-10 w-full h-4 bg-amber-900/50"></div>

                    {/* ไม้เซียมซี (แสดงตอนยังไม่เขย่า หรือกำลังเขย่า) */}
                    <div className="absolute -top-10 flex gap-2 justify-center w-full px-8">
                        <div className="w-3 h-24 bg-red-200 rounded-full transform -rotate-12 translate-y-8 border border-red-300"></div>
                        <div className="w-3 h-28 bg-red-300 rounded-full transform rotate-6 translate-y-4 border border-red-400"></div>
                        <div className="w-3 h-24 bg-red-200 rounded-full transform rotate-12 translate-y-8 border border-red-300"></div>
                    </div>

                    <span className="text-white font-bold text-lg select-none">
                        {isShaking ? "กำลังเขย่า..." : "แตะเพื่อเขย่า"}
                    </span>
                </div>

                {/* ปุ่มกด (เผื่อคนไม่แตะกระบอก) */}
                {!result && (
                    <button
                        onClick={handleShake}
                        disabled={isShaking}
                        className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transform transition active:scale-95 disabled:opacity-50"
                    >
                        {isShaking ? "เขย่าๆๆ..." : "เขย่าเซียมซี"}
                    </button>
                )}

                {/* ผลลัพธ์ (Modal หรือ Card) */}
                {result && (
                    <div className="animate-fade-in-up mt-6 bg-white border-2 border-amber-200 rounded-2xl p-6 shadow-2xl relative">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-red-500 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl border-4 border-white shadow-md">
                            {result.number}
                        </div>

                        <h2 className="text-2xl font-bold text-amber-800 mt-4 mb-2">{result.title}</h2>
                        <h3 className="text-xl text-red-600 font-semibold mb-2">"{result.text}"</h3>
                        <p className="text-gray-600 mb-4">{result.desc}</p>

                        <div className="bg-amber-50 rounded-lg p-2 mb-4 text-sm text-amber-800">
                            <span>สีมงคลประจำวันนี้: </span>
                            <span className="font-bold" style={{ color: result.luckyColor === 'สีเขียว' ? 'green' : result.luckyColor === 'สีทอง' ? '#D4AF37' : 'red' }}>
                                {result.luckyColor}
                            </span>
                        </div>

                        <button
                            onClick={resetGame}
                            className="text-amber-600 underline text-sm hover:text-amber-800"
                        >
                            เล่นอีกครั้ง
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SeamsiGamePage;